import { selectedText } from '@/apps/latest/components/organisms/PostRecordingView/homeVisitFields'

import { type CarePlan, type CarePlanLetterhead } from './carePlanApi'
import { type HomecareRecipient } from './homecareApi'
import {
  addresseeLines,
  ageOn,
  formatBirthDate,
  type PrintDocument,
  type ReportPage,
} from './printHomeVisitReport'
import { visibleCarePlanFields } from './useCarePlan'

// 計画書を紙に出す。報告書と同じ別窓・同じ型で、本文は 1 つ・宛名だけを宛先ごとに替える
// (yakureki-back log/263 決定 2)。並びはアイセイ P-CUBEn 取り込み用の計画書の様式
// (訪問薬剤管理指導計画書): 表題 → 宛名 → 患者 → 訪問予定日 → 見出しつきの文 → 結び → 薬局。
// 足の薬剤師は手で書く欄 (アカウントは店で共有なので、作った薬剤師を持たない)。

export const CARE_PLAN_TITLE = '訪問薬剤管理指導計画書'

export const carePlanDocument = (plan: CarePlan): PrintDocument => ({
  title: CARE_PLAN_TITLE,
  closing: '追加の指示がございましたらご連絡ください。',
  issuedOn: plan.created_at,
})

const japaneseDate = (value: string): string => {
  const [y, m, d] = value.split('-').map(Number)
  return `${y}年${m}月${d}日`
}

export const buildCarePlanPage = (
  plan: CarePlan,
  letterhead: CarePlanLetterhead,
  recipient: HomecareRecipient | null
): ReportPage => {
  const { patient, pharmacy } = letterhead
  const patientLine = [
    `患者氏名 ${patient.name} 様`,
    patient.birth_date
      ? `生年月日 ${formatBirthDate(patient.birth_date)} (${ageOn(
          patient.birth_date,
          new Date(plan.created_at)
        )}歳)`
      : '',
    patient.care_level ? `介護度 ${patient.care_level}` : '',
  ]
    .filter(Boolean)
    .join('　')

  const blocks = [
    {
      label: '訪問予定日',
      text: plan.scheduled_dates.map(japaneseDate).join('、'),
    },
    ...visibleCarePlanFields(plan).map(({ key, label }) => ({
      label,
      text: selectedText(plan.fields[key] ?? []),
    })),
  ].filter((block) => block.text)

  return {
    addressee: addresseeLines(recipient),
    patientLine,
    blocks,
    footer: [
      [
        pharmacy.name,
        pharmacy.phone_number ? `TEL ${pharmacy.phone_number}` : '',
      ]
        .filter(Boolean)
        .join('　'),
      '薬剤師　　　　　　　　　　印',
    ],
  }
}
